<template>
  <MainLayout v-if="currentPage === 'coverage'" :title="$t('pages.coverage')">
    <template slot="leftElements">
      <ChartFilters page="coverage" />
    </template>
    <template slot="rightElements">
      <VsDatePicker v-if="selectedDateRange" :selectedDate="selectedDateRange" @changedDate="changedDate" />
    </template>
    <div slot="content">
      <Coverage />
    </div>
  </MainLayout>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import MainLayout from "@/layouts/Main";
import Coverage from "@/components/coverage/Index";
import ChartFilters from "@/components/shared/ChartFilters/Index";

export default {
  components: {
    MainLayout,
    Coverage,
    ChartFilters,
  },
  computed: {
    ...mapGetters({
      selectedDateRange: "coverage/getCoverageDateRange",
      currentPage: "dashboard/currentPage",
    }),
  },
  created() {
    if (_.isEmpty(this.selectedDateRange)) {
      this.initDateRange();
    }
  },
  methods: {
    ...mapActions("coverage", ["initDateRange", "setCoverageDateRange"]),
    changedDate(changedDate) {
      this.setCoverageDateRange({
        startDate: changedDate.start,
        endDate: changedDate.end,
      });
    },
  },
};
</script>
